import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAccessToken } from "@/shared/infrastructure/auth/token-storage";
import { ForgotPasswordPage } from "@/modules/auth/presentation/pages/ForgotPasswordPage";

export const Route = createFileRoute("/forgot-password")({
  beforeLoad: () => {
    if (getAccessToken()) {
      throw redirect({ to: "/" });
    }
  },
  component: ForgotPasswordPage,
});
